import React, {createRef, useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import SubscribeModalCard from "./components/card";
import Stripe from "./stripe";
import useResponsive from "../hooks/responsive";
import {trackGaussEvent} from "../helper/analytics";

const features = [
    'Acceso a TODOS los cursos',
    'Acceso a los videos 24/7',
    'Dispositivos ilimitados',
    'Apuntes descargables',
    'Ejercicios resueltos',
    'Masterclass',
    'Acceso a nuestra comunidad',
    '7 días gratis',
]

export default function SubscribeModal({hasCard}) {
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [isMobile, maxWidthContainer] = useResponsive()
    const [isActive, setIsActive] = useState(false)
    const [selectedType, setSelectedType] = useState('month')
    const [hasPaymentMethod, setHasPaymentMethod] = useState(hasCard)
    const [transitionIn, setTransitionIn] = useState(false)
    const [isDiscountActive, setIsDiscountActive] = useState(false)

    useEffect(() => {
        // check user for discount
        fetch('/ajax/user/me')
            .then(m => m.json())
            .then(me => {
                if(me.error) return


                if(me.has_subscription_discount_active) setIsDiscountActive(true)

            }).catch(() => {
                console.log('user not loged in')
            })
    }, [])

    useEffect(() => {
        if(isActive) {
            setTimeout(() => setTransitionIn(true), 100)
            trackGaussEvent('buy_suscription_start_process', {})
        }
    }, [isActive])
    useEffect(() => {
        const l = (event) => {
            const t = event.detail

            setSelectedType(t);

            trackGaussEvent('buy_suscription_change_type', {newtype: t})
        }

        document.addEventListener('subcribe_modal_card_select', l)

        return () => {
            document.removeEventListener('subcribe_modal_card_select', l)
        }

    }, [])

    useEffect(() => {
        const l1 = () => setIsActive(true)
        document.addEventListener('subscribe_modal_trigger', l1)

        return () => {
            document.removeEventListener('subscribe_modal_trigger', l1)
        }
    }, [])

    const onClose = () => {
        setTransitionIn(false)
        setTimeout(() => setIsActive(false), 1000)
        trackGaussEvent('buy_suscription_close_process', {})
    }
    const suscribeAction = () => {
        if(isLoading) return
        setIsLoading(true)

        trackGaussEvent('buy_suscription_end_and_pay', {
            type: selectedType
        })

        // lets redirect to payment page
        location.href = `/buy/course/home/${selectedType === 'month' ? 'monthly' : 'year'}/subscription`
    }

    const trackBuyPaypal = () => {
        trackGaussEvent('buy_suscription_paypal', {
        })

    }

    if(!isActive) return null

    if(isSuccess) return (
        <Container>
            <SuccessMessage>Suscrito correctamente, la web se recargará automaticamente</SuccessMessage>
        </Container>
    )

    return(
        <Container transitionIn={transitionIn}>
            <CloseContainer isMobile={isMobile}><CloseIcon onClick={onClose}>cerrar</CloseIcon></CloseContainer>
            <Title>A un paso del aprobado</Title>
            {isDiscountActive && (
                <DiscountWrapper>
                    Hemos  activado un <b>descuento de 9€ en el primer pago de tu suscripción</b> por tiempo limitado
                </DiscountWrapper>
            )}
            <CardsContainer isMobile={isMobile}>

                <SubscribeModalCard defaultActive type={'month'} price={'10/€ mes'} title={'Suscripción Mensual'} />
                <SubscribeModalCard type={'semester'} price={'45/€ semestre'} title={'Suscripción Semestral'} />
            </CardsContainer>

            <LegendTitle>Lo que consigues al suscribirte</LegendTitle>
            <LegendContainer>
                {features.map((feature, indx) => <Legend key={`feature_${indx}`}>{feature}</Legend>)}
            </LegendContainer>

            {!selectedType && (<PaymentErrorNotSelectedType>Selecciona un tipo de suscripción</PaymentErrorNotSelectedType>)}
            {selectedType && (
            <PaymentContainer>
                {!hasPaymentMethod && (
                    <StripeContainer>
                        <PaymentTitle>Completa tus datos para continuar</PaymentTitle>
                        <StripeIconContainer>
                            <StripeIconImage src='/images/powered_stripe.png' />
                        </StripeIconContainer>

                        <Stripe onFinish={() => setHasPaymentMethod(true)} />

                    </StripeContainer>
                )}


                {hasPaymentMethod && (
                    <PaymentActionContainer>
                        <ButtonPay onClick={suscribeAction}>
                            {isLoading ? 'Cargando...' : selectedType === 'month' ?  'Pagar suscripción mensual por 10 €' : 'Pagar suscripción semestral por 45 €'}
                        </ButtonPay>
                    </PaymentActionContainer>
                )}


                {selectedType === 'semester' && (
                    <PaypalContainer>
                        <PaypalMessage>- tambien puedes pagar tu suscripción semestral con Paypal -</PaypalMessage>
                        <PaypalImageContainer>
                            <a onClick={trackBuyPaypal} href='/buy/paypal/subscription'><PaypalImage src="https://www.paypalobjects.com/webstatic/mktg/logo-center/logotipo_paypal_pagos.png"  /></a>
                        </PaypalImageContainer>
                    </PaypalContainer>
                )}

            </PaymentContainer>
            )}

        </Container>
    )
}

const DiscountWrapper = styled.div`
    text-align: center;
    color: #f58397;
    padding-top: 24px;
    padding-bottom: 24px;
`

const CloseContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding-right: 24px;
    padding-bottom: ${props => props.isMobile ? '24px' : 0};
`

const CloseIcon = styled.div`
    color: white;
    font-size: 18px;
    cursor: pointer;

    &:hover {
        color: #FA9F64;
    }
`


const SuccessMessage = styled.div`

    font-size: 22px;
    color: white;
    text-align: center;
`

const PaypalContainer = styled.div`

      padding-top: 24px;

`

const PaypalImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content:center;
    padding-top: 24px;
`

const PaypalImage = styled.img`

`
const PaypalMessage = styled.div`
    text-align: center;
    font-size: 14px;
    color: white;
`

const ButtonPay = styled.div`

    border: 1px solid #63C7B2;
    color: #63C7B2;
    padding: 12px;
    cursor: pointer;
    font-size: 18px;
    border-radius: 4px;

    &:hover {
        border-color: #FA9F64;
        color: #FA9F64;
    }

`
const PaymentActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content:center;
    padding-top: 24px;
`

const StripeIconContainer = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content:center;

`

const StripeIconImage = styled.img`
    width: 150px;
    margin: auto;

`


const PaymentTitle  = styled.div`
 text-align: center;
    font-size: 18px;

    color: white;
    padding-bottom: 18px;
`

const StripeContainer = styled.div`
    padding: 24px 56px;
`

const PaymentErrorNotSelectedType = styled.div`
    color: #8B2635;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    padding-top: 48px;
`

const PaymentContainer = styled.div`
    margin: auto;
    max-width: 800px;
`

const LegendTitle = styled.div`
    padding-top: 24px;
    text-align: center;
    color: #FA9F64;
    font-size: 14px;
`
const LegendContainer = styled.div`
    margin: auto;
    max-width: 800px;
    padding: 16px;
    display: flex;
    flex-direction : row;
    flex-wrap: wrap;
    justify-content: center
`

const Legend = styled.div`
    margin: 8px;
`
const CardsContainer = styled.div`
    margin: auto;
    display: flex;
    flex-direction: ${props => props.isMobile ? 'column' : 'row'};
    justify-content: space-around;
    max-width: 800px;
    padding: 16px;

`
const Container = styled.div`
    position: absolute;
    z-index: 19;
    height: 100vh;
    width: 100vw;
    top:0;
    left: 0;
    background-color: black;
    padding-top: 100px;
    -webkit-transition: -webkit-transform 0.5s ease;
    -moz-transition: -moz-transform 0.5s ease;
    -o-transition: -o-transform 0.5s ease;
    transition: transform 1s ease;
    transform: translate(0, ${props => props.transitionIn ? '0' : '100vh'});

`

const Title = styled.div`
    text-align: center;
    color: white;
    font-size: 22px;
    font-weight: bold;
    padding-bottom: 24px;
`


if (document.getElementsByTagName('subscribe-modal')) {
    const elms = document.getElementsByTagName('subscribe-modal')

    for(let elm of elms) {
        const hasCard = elm.attributes['has-card'].value === '1'
        ReactDOM.render(<SubscribeModal hasCard={hasCard} />, elm);
    }
}
